import { getContentListServerSideProps } from '../../lib/content-list-retriever'
import { CollectionScreen } from 'app/features/collection/screen'
import { GetServerSideProps } from 'next'
import retrieveLastVideo from '../../lib/last-video-retriever'

export const getServerSideProps: GetServerSideProps = async (context) => {
  const lastVideo = await retrieveLastVideo(
    context,
    context.query.slug as string
  )

  if (lastVideo?.isSeries) {
    return {
      redirect: {
        destination: `/series/${context.query.slug}/${lastVideo.content.slug}`,
        permanent: false,
      },
    }
  }

  return await getContentListServerSideProps('Collection')(context)
}

export default function CollectionPage() {
  return <CollectionScreen type={'Collection'} />
}
